var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTodoTaskPerfomance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_17810",
    "data-name": "Group 17810",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_34721",
    "data-name": "Path 34721",
    d: "M0,0H24V24H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_34722",
    "data-name": "Path 34722",
    d: "M19,22H5a3,3,0,0,1-3-3V3A1,1,0,0,1,3,2H17a1,1,0,0,1,1,1V15h4v4A3,3,0,0,1,19,22Zm-1-5v2a1,1,0,0,0,2,0V17Zm-2,3V4H4V19a1,1,0,0,0,1,1ZM6,7h8V9H6Zm0,4h8v2H6Zm0,4h5v2H6Z",
    fill: "#aaa"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTodoTaskPerfomance);
export default __webpack_public_path__ + "static/media/todo_task_perfomance.735ed5ee64a880fcbd35f765b56c7782.svg";
export { ForwardRef as ReactComponent };